import { ClockIcon } from "@phosphor-icons/react";
import StatusBadge from "./StatusBadge";

export default function StatusTimeline({ entries }) {
  if (!entries || entries.length === 0) {
    return (
      <div className="text-xs text-slate-500 py-2" data-testid="status-timeline-empty">
        No status events yet.
      </div>
    );
  }
  return (
    <ol data-testid="status-timeline" className="space-y-3">
      {entries.map((e) => (
        <li key={e.id} className="flex items-start gap-3 text-sm" data-testid={`status-log-entry-${e.id}`}>
          <ClockIcon
            size={14}
            weight="duotone"
            className="mt-1 text-slate-400 shrink-0"
          />
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <StatusBadge value={e.status} />
              <span className="text-[11px] text-slate-500 tabular font-medium">
                {new Date(e.timestamp).toLocaleString()}
              </span>
            </div>
            {e.user_name && (
              <div className="text-xs text-slate-700 mt-1">by {e.user_name}</div>
            )}
            {e.note && (
              <div className="text-xs text-slate-600 mt-1 italic">"{e.note}"</div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
